<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { interpolateHeadAndBody } from './helpers';
    import NativeHtmlEmbedContent from './variations/NativeHtmlEmbedContent.svelte';
    import PredefinedEmbeds from './variations/PredefinedEmbeds.svelte';
    import SandboxedHtmlEmbedContent from './variations/SandboxedHtmlEmbedContent.svelte';
    import Box from '../_wrappers/Box.svelte';

    import type { TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    // General note:
    // Embed for "custom-html" providers shall be either embedded in a separate
    // cross-origin "sandbox" iframe or natively.
    //
    // This is not necessary/wanted for the other embeds (like Google, ProvenExpert, etc.).
    // That's why I (Peter) favored separate component implementations instead
    // of one big generic component to keep things simple.
    //
    // Now we have SandboxedHtmlEmbedContent, NativeHtmlEmbedContent and
    // PredefinedEmbeds (like Google Maps, Proven Expert, etc.).

    export let id = '';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let box = {};
    export let bgColor = 'transparent';
    export let provider = '';
    export let head = '';
    export let body = '';
    export let embedCustomHtmlNatively = false;
    export let campaignId: string;
    export let trackingProperties: TrackingProperty[];
    export let globalVariables: Record<string, string> = {};
    // Forwarded to SandboxedHtmlEmbedContent via $$props (loading min-height scoping)
    export let layout = DEFAULT_LAYOUT;
</script>

{#if head || body}
    <Box {id} {...box} backgroundColor={bgColor} {transitionDelay} {transitionEffect}>
        {#if provider === 'custom-html' && embedCustomHtmlNatively}
            <!--
                Note: AI content is intentionally not allowed in the native path —
                AI-generated CSS routinely uses global selectors (`*`, `body`, `:root`)
                that would bleed into the host funnel page. AI always goes through
                the sandboxed iframe below.
            -->
            <NativeHtmlEmbedContent
                {...$$props}
                {...interpolateHeadAndBody(trackingProperties, globalVariables, campaignId, {
                    head,
                    body,
                })}
            />
        {:else if (provider === 'custom-html' && !embedCustomHtmlNatively) || provider === 'ai'}
            <SandboxedHtmlEmbedContent
                {...$$props}
                {...interpolateHeadAndBody(trackingProperties, globalVariables, campaignId, {
                    head,
                    body,
                })}
            />
        {:else}
            <PredefinedEmbeds {...$$props} />
        {/if}
    </Box>
{/if}
